import { render, staticRenderFns } from "./OrderProduced.vue?vue&type=template&id=11757e84"
import script from "./OrderProduced.vue?vue&type=script&lang=js"
export * from "./OrderProduced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports